// This constants NEEDS to match the Issue model variables in the Back-End  >>  "app/models/issue.rb"

const IssueTypes = {
  CARD_INFORMATION_MISSING: 1, // Custom id
};

export default IssueTypes;